import { DeclarationConstants } from '../constants/global';
import StatusConfigService from '../services/statusConfig';
import { StatusConfigData } from '../services/statusConfig/types';
import StoreConfigService from '../services/storeConfig';
import { StoreConfigData } from '../services/storeConfig/types';
import { HandleUpdateUserProfileInterface } from './types';

export const handleUpdateUserProfile: HandleUpdateUserProfileInterface =
  async ({ setProfile, isLoggedIn }) => {
    if (isLoggedIn) {
      try {
        // const response = await UserService.getUserProfile();
        // if (response) {
        //   setProfile(response);
        // } else throw new Error(DeclarationConstants.NO_RESPONSE_ERROR_MESSAGE);
      } catch (error) {
        setProfile(null);
      }
    } else {
      setProfile(null);
    }
  };

export const handleSetStatusConfig = async (
  setStatusConfig: (data: StatusConfigData) => void
) => {
  try {
    const response = await StatusConfigService.getStatusConfig();
    if (response) {
      setStatusConfig(response);
    } else throw new Error(DeclarationConstants.NO_RESPONSE_ERROR_MESSAGE);
  } catch (error) {
    setStatusConfig({
      approvalStatus: [],
    });
  }
};

export const handleSetStoreConfig = async (
  setStoreConfig: (data: StoreConfigData) => void
) => {
  try {
    const response = await StoreConfigService.getStoreConfig();
    if (response) {
      setStoreConfig(response);
    } else throw new Error(DeclarationConstants.NO_RESPONSE_ERROR_MESSAGE);
  } catch (error) {
    setStoreConfig({});
  }
};
